import * as React from "react";
import Modal from "@mui/material/Modal";
import CustomButton from "../../common/button/CustomButton";
import profile from "../../../assets/images/vector-shop-icon.png";
import theme from "../../../theme";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import { StyledBoxAuto } from "../auto-split-calculation/style";
import {
  ButtonWrapper,
  StyledBox,
  StyledBoxBorder,
  StyledBoxCard,
  StyledBoxFlex,
  StyledTypography,
  StyledTypographyGroupCart,
} from "./style";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
export default function Confirmation({
  open,
  handleClose,
  message,
  heading,
  confirmButtonLabel,
  type = "info",
  onConfirm,
}) {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <img src={profile} alt="profile" loading="lazy" />

            <StyledTypography>{heading}</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <StyledBoxAuto>
          <StyledBoxBorder>
            <StyledTypographyGroupCart type={type}>
              {type === "error" && (
                <ErrorOutlineIcon
                  sx={{
                    verticalAlign: "middle",
                  }}
                />
              )}
              {message}
            </StyledTypographyGroupCart>
            
          </StyledBoxBorder>
        </StyledBoxAuto>

        <ButtonWrapper>
          <CustomButton
            padding="10px 37px"
            fontSize={theme.typography.regular.fontSize}
            height="44px"
            btnLabel="Close"
            btntype={"white"}
            color={theme.palette.custom.lockerValueColor}
            fontWeight={theme.typography.fontWeight.medium}
            border={theme.borders.defaultButton}
            onClick={() => handleClose()}
          />
          {type !== "error" && (
            <CustomButton
              padding="10px 37px"
              btntype={type === "delete" ? "danger" : "primary"}
              color={theme.palette.custom.white}
              btnLabel={confirmButtonLabel}
              onClick={() => {
                handleClose();
                onConfirm && onConfirm();
              }}
            />
          )}
        </ButtonWrapper>
      </StyledBox>
    </Modal>
  );
}
